export default __webpack_public_path__ + "static/media/img1.4760c087.png";